import { NGM_DEV_CLI_NAME } from '../constants';

export const getWatermark = (repoUrl: string, blockName?: string): string => {
	return `Installed from ${repoUrl.replace('/api/registry', '')}${blockName ? `\nUpdate this file using \`npx ${NGM_DEV_CLI_NAME} update ${blockName}\`` : ''}`;
};
